import { axios } from '@Root/API'

export const edit = ({ id, name }) => {
	return axios.put(`edit/program-awarding-body/${id}`, { name })
}
